<!-- Транспорт -->
<template>
  <li
    v-if="canSeePage('vehicles')"
    class="nav-item"
    role="button"
    tabindex="0"
    @click="navigate($event, 'Vehicles')"
    @mouseup="handleMiddleClick($event, 'Vehicles')"
    @contextmenu.prevent.stop="showContextMenu($event, 'Vehicles')"
    :class="{ active: activeItem === 'vehicles' }"
    :title="collapsed ? 'Транспорт' : ''"
  >
    <div class="link-icon_box">
      <svg
        class="vehicles__icon"
        fill="#ffffff"
        width="24px"
        height="24px"
        viewBox="0 0 50 50"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.84375 13C1.273438 13 0 14.277344 0 15.84375L0 42C0 43.566406 1.429688 45 3 45L7.09375 45C7.570313 47.835938 10.03125 50 13 50C15.96875 50 18.429688 47.835938 18.90625 45L28.15625 45C29.722656 45 31 43.722656 31 42.15625L31 15.90625C31 14.304688 29.738281 13 28.1875 13 Z M 33 20L33 45C33.480469 47.832031 36.03125 50 39 50C41.96875 50 44.429688 47.832031 44.90625 45L47 45C48.570313 45 50 43.570313 50 42L50 32.375C50 30.363281 48.550781 28.308594 48.375 28.0625L44.21875 22.5C43.265625 21.351563 41.769531 20 40 20 Z M 38 25L43.59375 25L46.78125 29.25C47.121094 29.730469 48 31.203125 48 32.375L48 33L38 33C37 33 36 32 36 31L36 27C36 25.894531 37 25 38 25 Z M 13 40C15.207031 40 17 41.792969 17 44C17 46.207031 15.207031 48 13 48C10.792969 48 9 46.207031 9 44C9 41.792969 10.792969 40 13 40 Z M 39 40C41.207031 40 43 41.792969 43 44C43 46.207031 41.207031 48 39 48C36.792969 48 35 46.207031 35 44C35 41.792969 36.792969 40 39 40Z"
        />
      </svg>
    </div>
    <span v-if="!collapsed" class="nav-link">Транспорт</span>
  </li>
</template>

<script>
import {
  useSidebarItem,
  sidebarItemProps,
} from "@/composables/useSidebarItem";

export default {
  name: "VehiclesItem",
  props: sidebarItemProps,
  emits: ["navigate", "middle-click", "context-menu"],
  setup(props, { emit }) {
    return useSidebarItem(emit);
  },
};
</script>
